(angular => {
  "use strict";


  angular.module("Pages").controller("Pages.EventManualUploadCtrl", [
    "$scope",
    "$timeout",
    "Loader",
    "Toast",
    "$routeParams",
    "EventService",
    "EventManualUploadService",
    EventManualUploadCtrl
  ]);

  function EventManualUploadCtrl($scope, $timeout, Loader, Toast, $routeParams, eventService, EventManualUploadService) {
    this.pagination = { page: 1, limit: 10 };
    this.form = ($event, model) => {
      EventManualUploadService.form($event, model).then(() => {
        this.loadManualUploads();
      });
    };

    this.loadManualUploads = () => {
      EventManualUploadService.list().then(manuals => {
        this.manuals = manuals;
      }).catch(err => Toast.httpHandler(err));
    };
    this.loadManualUploads();


    this.onPaginate = () => {
      $scope.$emit("scroll-top");
    };

  }
})(angular || {});
